import React, { useEffect } from 'react';
import { RouteEntity } from '../../../../../base/domain/entities';
import { useCurrentRoute } from '../../../../../base/presentation/hooks';
import {
  authHelper,
  historyRoute,
} from '../../../../../base/infrastructure/helpers';
import { Navigate } from 'react-router-dom';

interface AuthProtectorProps {
  children: JSX.Element | React.ReactNode;
  routeItem: RouteEntity;
}

export function AuthRouterProtector(props: AuthProtectorProps) {
  const { children, routeItem } = props;
  const [currentRoute] = useCurrentRoute(routeItem);
  const account = authHelper.getAccount();
  useEffect(() => {
    if (currentRoute) historyRoute.pushHistoryRoute(currentRoute);
  }, [currentRoute]);

  const skipAuth = process.env.REACT_APP_SKIP_AUTH ?? 'NO';
  const loginUrl = process.env.REACT_APP_LOGIN_URL ?? '/auth/login';

  if (!account && skipAuth === 'NO') {
    const axisBefore = localStorage.getItem('url_before_login');
    if (!axisBefore) {
      const urlBeforeLogin = window.location.href;
      localStorage.setItem('url_before_login', urlBeforeLogin);
    }

    return <Navigate to={loginUrl} replace />;
  }
  return <div>{children}</div>;
}
